import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ACTIVE_Notify_FETCH_STOP } from "../Reducer/ActiveNotifyReducer";
import { Link } from "react-router-dom";
import "./Notify.css";

const getNotificationLink = (data) => {
    const type = data?.type ?? data?.type1;
    const url = data?.app_url;
    if (type == 4) return `/contact/${url}`;
    if (type == 0 || type == 6) return `/meeting-details/${url}`;
    if (type == 7) return `/stories/${url}`;
    if (type === 'audio_room') return url ? `/audio-rooms/join/${url}` : `/audio-rooms`;
    return `/post/${url}`;
};

export default function Notify() {
    const selector = useSelector((state) => state.activeNotifyReducer);
    const dispatch = useDispatch();

    const hideMessage = () => dispatch(ACTIVE_Notify_FETCH_STOP());

    useEffect(() => {
        if (!selector?.loading) return undefined;
        const timer = setTimeout(hideMessage, 12000);
        return () => clearTimeout(timer);
    }, [selector, dispatch]);

    if (!selector?.loading) return null;

    const data = selector?.data;

    return (
        <div className="app-notify" role="status" aria-live="polite">
            <Link
                to={getNotificationLink(data)}
                className="app-notify__link"
                onClick={hideMessage}
            >
                <div className="app-notify__avatar-wrap">
                    <div
                        className="app-notify__avatar"
                        style={{ backgroundImage: `url("${data?.avatar}")` }}
                    />
                    <span className="app-notify__reaction">
                        <i className="fa-solid fa-thumbs-up" />
                    </span>
                </div>
                <div className="app-notify__content">
                    {data?.title && <div className="app-notify__title">{data.title}</div>}
                    {data?.details && <div className="app-notify__body">{data.details}</div>}
                    <div className="app-notify__meta">A few seconds ago</div>
                </div>
            </Link>
            <button
                type="button"
                className="app-notify__close"
                onClick={hideMessage}
                aria-label="Dismiss notification"
            >
                <i className="fa-solid fa-xmark" />
            </button>
        </div>
    );
}
